import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ec55d9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ttn-invoices-table__header" }
const _hoisted_2 = { class: "main__information" }
const _hoisted_3 = { class: "information__title" }
const _hoisted_4 = { class: "information__parameter" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parameter__name" }, "Вес", -1))
const _hoisted_6 = { class: "parameter__value" }
const _hoisted_7 = { class: "information__parameter" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parameter__name" }, "Кубатура", -1))
const _hoisted_9 = { class: "parameter__value" }
const _hoisted_10 = { class: "information__parameter" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parameter__name" }, "Объемный вес", -1))
const _hoisted_12 = { class: "parameter__value" }
const _hoisted_13 = { class: "information__parameter" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parameter__name" }, "Количество накладных", -1))
const _hoisted_15 = { class: "parameter__value" }
const _hoisted_16 = { class: "information__parameter" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parameter__name" }, "Количество мест", -1))
const _hoisted_18 = { class: "parameter__value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.72353 13.6095C4.24423 14.1302 5.08845 14.1302 5.60915 13.6095L9.99967 9.21895L14.3902 13.6095C14.9109 14.1302 15.7551 14.1302 16.2758 13.6095C16.7965 13.0888 16.7965 12.2446 16.2758 11.7239L10.9425 6.39052C10.4218 5.86983 9.57756 5.86983 9.05686 6.39052L3.72353 11.7239C3.20283 12.2446 3.20283 13.0888 3.72353 13.6095Z",
    fill: "#0F172A"
  })
], -1))
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"header__columns\" data-v-4ec55d9e><div class=\"columns__column\" data-v-4ec55d9e>Номер накладной</div><div class=\"columns__column\" data-v-4ec55d9e>Город назначения</div><div class=\"columns__column\" data-v-4ec55d9e>Клиент</div><div class=\"columns__column\" data-v-4ec55d9e>Кубатура</div><div class=\"columns__column\" data-v-4ec55d9e>Физ. вес</div><div class=\"columns__column\" data-v-4ec55d9e>Объемный вес</div><div class=\"columns__column\" data-v-4ec55d9e>Количество мест</div></div>", 1)
const _hoisted_21 = { class: "ttn-invoices-table__content" }
const _hoisted_22 = { class: "columns__column" }
const _hoisted_23 = { class: "columns__column" }
const _hoisted_24 = { class: "columns__column" }
const _hoisted_25 = { class: "columns__column" }
const _hoisted_26 = { class: "columns__column" }
const _hoisted_27 = { class: "columns__column" }
const _hoisted_28 = { class: "columns__column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ttn-invoices-table", { 'table--opened': _ctx.state.is_opened }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "header__main",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.viewKey === 'direction' ? _ctx.direction.directionName : _ctx.direction.sectorName), 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.direction.totalWeight), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.direction.totalVolume), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.direction.totalVolumeWeight), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.direction.invoiceCount), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.direction.placeCount), 1)
          ])
        ]),
        _hoisted_19
      ]),
      _hoisted_20
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.direction.invoices, (invoice) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "content__columns",
          key: invoice.invoiceId
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_router_link, {
              target: "_blank",
              to: `/invoice/${invoice.invoiceId}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(invoice.invoiceNumber), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _createElementVNode("div", _hoisted_23, _toDisplayString(invoice.whereCityName), 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString(invoice.companyName), 1),
          _createElementVNode("div", _hoisted_25, _toDisplayString(invoice.cubature), 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString(invoice.weight), 1),
          _createElementVNode("div", _hoisted_27, _toDisplayString(invoice.volumeWeight), 1),
          _createElementVNode("div", _hoisted_28, _toDisplayString(invoice.places), 1)
        ]))
      }), 128))
    ])
  ], 2))
}